import styled from 'styled-components';

// The Influencer form is visually identical to the Affiliate form, so it reuses
// the same shared form tokens (the ONLY place raw colours may live).
import { AFFILIATE_FORM, COLORS } from '../../../../theme/tokens';
import { Text } from '../../../../components';

// The dialog chrome (backdrop / sheet / header / pinned footer) now comes from the
// shared `Overlay`, and every text input from the shared `Field`, so this form
// reads identically to the Settings forms. What remains here is only the bits the
// shared components don't cover: the Deal-Type segmented chips, the fixed-cost
// helper line and the "unique tracking link" info card.

// --- Field group (a label above a non-Field control, e.g. the Deal-Type chips) --
// Mirrors the shared Field's label-to-control rhythm (8px gap) and label type.
export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const GroupLabel = styled(Text)`
  font-size: 14px;
  color: ${COLORS.text};
`;

// --- Deal-type segmented chips ----------------------------------------------
export const DealChips = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`;

export const DealChip = styled.button<{ $selected: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  min-width: 48px;
  height: 48px;
  padding: 0 15px;
  border-radius: 12px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid ${(p) => (p.$selected ? AFFILIATE_FORM.chipSelBorder : AFFILIATE_FORM.chipBorder)};
  background: ${(p) => (p.$selected ? AFFILIATE_FORM.chipSelBg : AFFILIATE_FORM.chipBg)};
  color: ${(p) => (p.$selected ? AFFILIATE_FORM.chipSelText : AFFILIATE_FORM.chipText)};
  transition: border-color 150ms ease, background 150ms ease, color 150ms ease;
`;

// --- Fixed-cost helper line --------------------------------------------------
export const Helper = styled(Text)`
  font-size: 13px;
  line-height: 1.35;
  color: ${COLORS.textMuted};
`;

// --- "Unique tracking link" info card ----------------------------------------
export const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 16px;
  border-radius: 12px;
  border: 0.5px solid ${AFFILIATE_FORM.infoBorder};
  background: ${AFFILIATE_FORM.infoBg};
`;

export const InfoTitle = styled(Text)`
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
  color: ${AFFILIATE_FORM.infoTitle};
`;

export const InfoBody = styled(Text)`
  font-size: 13px;
  font-weight: 300;
  line-height: 1.4;
  color: ${AFFILIATE_FORM.infoBody};
`;
